import { ArrowDownCircle, CheckCircle, XCircle } from "lucide-react";
import { match } from "ts-pattern";

import type { SanctionResult } from "@/lib/ratings/sanction";
import { getSanctionLabel, getSanctionLevel } from "@/lib/ratings/sanction";

export function SanctionBadge({
  sanction,
  divisionName,
  showDowngradedLevel = false,
}: {
  sanction: SanctionResult;
  divisionName: string;
  /**
   * Admin reporting only. Everywhere else a downgraded division reads
   * "Not sanctioned" — naming the level it dropped to was removed from
   * TD- and player-facing surfaces per client request (#315).
   */
  showDowngradedLevel?: boolean;
}) {
  const level = getSanctionLevel(sanction, divisionName);
  const display =
    level === "downgraded" && !showDowngradedLevel ? "unsanctioned" : level;

  return match(display)
    .with("sanctioned", () => (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-green-700">
        <CheckCircle size={14} />
        Sanctioned
      </span>
    ))
    .with("downgraded", () => (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-amber-700">
        <ArrowDownCircle size={14} />
        {getSanctionLabel(sanction, divisionName)}
      </span>
    ))
    .with("unsanctioned", () => (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-red-600">
        <XCircle size={14} />
        Not sanctioned
      </span>
    ))
    .exhaustive();
}
